<button matRipple (click)="download()" class="button" [disabled]="!downloadLink" [title]="buttonTitle | translate">
    {{ 'general.download' | translate }}
</button>
  